export default __webpack_public_path__ + "static/media/btn_audiocomics_default.7a3afcdc.png";